/*
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-07-27 15:10:08
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-09-24 13:04:19
 * @FilePath: \ces-vue-serve\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import Vuex from 'vuex';
import enumeration from './modules/enumeration';
import pagesTemporary from './modules/pagesTemporary';
import { getIsCurrentApprover, getLoginUser } from '../API/index';
import { getRebateLoginUser } from '../API/user/rebateUser';
import { tickToGetToken, getAutoMenus } from '../API/autoRebateAxios.js';
import Cookies from 'js-cookies';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    user: null,
    needShow: false,
    isCollapse: false,
    autoRebateMenuList: []
  },
  getters: {
    // 是否代理商 有值的都是代理商
    isAgent (state) {
      return state.user.signType && state.user.signType.length;
    }
  },
  mutations: {
    setUser (state, data) {
      // 设置data 下面userid
      if (data.userId) {
        data.userId = data.userId.toUpperCase();
      }
      state.user = data;
      // state.user.perssimionCodeList.push('orderBoard');
    },
    showWhite (state, bollen) {
      state.needShow = bollen;
    },
    SET_COLLAPSE (state, boolean) {
      state.isCollapse = boolean;
    },
    SET_AUTO_REBATE_MENU_LIST (state, menuList) {
      state.autoRebateMenuList = Array.isArray(menuList) ? menuList : [];
    }
  },
  actions: {
    getuser ({ commit, state }, sidLogin) {
      return new Promise((resolve, reject) => {
        if (state.user !== null && state.user !== '') {
          resolve(state.user);
          return;
        }
        getLoginUser().then(async (res) => {
          const { status, data } = res.data;
          let user = {};
          if (status === '200') {
            user = data;
            window.$core = window.$core || {};
            window.$core.user = { userId: user.userId, userName: user.userName };
            window.$core.locale = 'zh';
            try {
              let autoForm = {};
              if (localStorage.getItem('union_session_ticket')) {
                autoForm = { ticket: localStorage.getItem('union_session_ticket') };
              } else {
                autoForm = {
                  partnerUser: Cookies.getItem('PartnerUser'),
                  ruijieportal: Cookies.getItem('ruijieportal')
                };
              }
              const autoToken = await tickToGetToken(autoForm);
              const token = autoToken && autoToken.data ? autoToken.data.token : '';
              localStorage.setItem('autoToken', token || '');
              const autoMenusRes = await getAutoMenus();
              const autoMenuList = autoMenusRes && autoMenusRes.data ? autoMenusRes.data.menuList : [];
              commit('SET_AUTO_REBATE_MENU_LIST', autoMenuList);
              console.log('获取token成功', token);
            } catch (err) {
              localStorage.removeItem('autoToken');
              console.log('获取token失败', err);
            }
            if (localStorage.getItem('loginType') === 'nbqd') {
              commit('setUser', user);
              resolve(user);
              return;
            }
            getRebateLoginUser().then((val) => {
              const { status, data } = val;
              if (status === '200') {
                user.perssimionCodeList = [
                  ...user.perssimionCodeList,
                  ...data.perssimionCodeList
                ];
                // 国际: 电池认证管理,当前登录用户按钮操作权限集合
                user.perssimionBatteryManagement = user.perssimionButtonList;
                // user.perssimionCodeList = [];
                commit('setUser', user);
                resolve(user);
              } else if (status === '302') {
                reject(new Error(`${val.status}-${val.data}`));
              } else {
                reject(new Error('noUser'));
              }
            });
          } else if (status === 'SSO-100024') {
            setTimeout(() => {
              let loginFrom = localStorage.getItem('loginFrom');
              window.localStorage.removeItem('union_session_ticket');
              window.localStorage.removeItem('loginType');
              if (loginFrom === 'oa') {
                window.location.href = `https://web-e-gw.ruijie.com.cn/api/union-session/login/c0c73417cf58cb87e146a78f6e44ef44?type=sid&reurl=${
                  window.location.origin + '/toLoginPage'
                }`;
              } else {
                window.location.href = `https://sid.ruijie.com.cn/logout?service=${encodeURIComponent(window.location.origin)}/toLoginPage`;
              }
            }, 2000);
          } else {
            let loginFrom = localStorage.getItem('loginFrom');
            window.localStorage.removeItem('union_session_ticket');
            window.localStorage.removeItem('loginType');
            if (loginFrom === 'oa') {
              window.location.href = `https://web-e-gw.ruijie.com.cn/api/union-session/login/c0c73417cf58cb87e146a78f6e44ef44?type=sid&reurl=${
                window.location.origin + '/toLoginPage'
              }`;
            } else {
              reject(new Error('noUser'));
            }
          }
        }).catch(() => {
          let loginFrom = localStorage.getItem('loginFrom');
          window.localStorage.removeItem('union_session_ticket');
          window.localStorage.removeItem('loginType');
          if (loginFrom === 'oa') {
            window.location.href = `https://web-e-gw.ruijie.com.cn/api/union-session/login/c0c73417cf58cb87e146a78f6e44ef44?type=sid&reurl=${
              window.location.origin + '/toLoginPage'
            }`;
          } else {
            window.location.href = `https://sid.ruijie.com.cn/logout?service=${encodeURIComponent(window.location.origin)}/toLoginPage`;
          }
        });
        // axios.all([
        //   getLoginUser(),
        //   getRebateLoginUser(sidLogin)
        // ]).then((res) => {
        //   let user = {};
        //   let json1 = res[0].data;
        //   if (json1.status === '200') {
        //     user = json1.data;
        //   } else {
        //     reject(new Error('noUser'));
        //   }
        //   let json2 = res[1];
        //   if (json2.status === '200') {
        //     user.perssimionCodeList = [...user.perssimionCodeList, ...json2.data.perssimionCodeList];
        //     // user.perssimionCodeList = [];
        //     commit('setUser', user);

        //     resolve(user);
        //   } else if (json2.status === '302') {
        //     reject(new Error(`${json2.status}-${json2.data}`));
        //   } else {
        //     reject(new Error('noUser'));
        //   }
        // }).catch((err) => {
        //   console.log(err);
        // });
        // getLoginUser().then((res) => {
        //   let json = res.data;
        //   if (json.status === '200') {
        //     if (json.data.perssimionCodeList.length === 0) {
        //       reject(new Error('noList'));
        //     } else {
        //       commit('setUser', json.data);
        //       resolve(json.data);
        //     }
        //   } else if (json.status === '302') {
        //     reject(new Error(`${json.status}-${json.data}`));
        //   } else {
        //     reject(new Error('noUser'));
        //   }
        // }).catch((response) => {
        //   reject(new Error('serviceError'));
        // });
      });
    },
    getIsCurrentApprover ({ commit, state }, strDocmentId) {
      // 判断是否是当前审批人
      return new Promise((resolve, reject) => {
        getIsCurrentApprover(strDocmentId)
          .then((res) => {
            let json = res.data;
            if (json.status === '200') {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
    }
  },
  modules: {
    enumeration,
    pagesTemporary
  }
});
